<app-traitement-data titre="OBS"
    [sousTitre]="(activite != 'O2PPC' || activite != 'O2VNI' ? patient!.obs?.date : patient!.tableauDeBord?.obs?.date) | aLaDateDu"
    [statut]="((activite != 'O2PPC' || activite != 'O2VNI' ? patient!.obs : patient!.tableauDeBord?.obs) | obsStatut)">
    {{ ((activite != 'O2PPC' || activite != 'O2VNI' ? patient!.obs?.value : patient!.tableauDeBord?.obs?.value) | obs)
    ?? 'Pas de donnée' }}
</app-traitement-data>